@if (travelSolution.trains) {
  <div collapsedHeight="auto" expandedHeight="auto">
    <trenitalia-travel-solution-header
      [travelSolution]="travelSolution"
      [isSelected]="isSelected"
      (onSelect)="onSelect.emit()"
      (onDetails)="onDetails.emit()"
    ></trenitalia-travel-solution-header>
  </div>
}
<div [@slideInOut]="isSelected && !['edit-date-time'].includes(checkoutDataMode) || isDetailsOpen">
  @if (isSelected && travelSolution.saleable &&!['edit-date-time'].includes(checkoutDataMode) && !isCarnet) {
    <div style="padding: 0 24px 16px;">
      <trenitalia-prices [travel-solution]="travelSolution" (select-price)="onPriceSelected.emit($event)"></trenitalia-prices>
    </div>
  }
  @if (isDetailsOpen) {
    <div class="container">
      <trenitalia-travel-solution-train-details [travelSolution]="travelSolution"></trenitalia-travel-solution-train-details>
    </div>
  }
  @if (isSelected && checkoutDataMode==='carnet') {
    <div>
      <mat-form-field appearance="fill" class="fx-flex">
        <mat-label>Seleziona servizio</mat-label>
        <mat-select [value]="selectedServiceCarnet"
          (selectionChange)="onCarnetChange.emit($event)">
          @for (service of selectCarnet; track service) {
            <mat-option [value]="service.id">
              {{service.value}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
  @if (isSelected && travelSolution.saleable && !['edit-date-time'].includes(checkoutDataMode)) {
    <div class="footer-result flex-row items-center justify-between">
      <div>
        @if (['travel','travel-change','carnet','edit'].includes(checkoutDataMode)) {
          <mat-slide-toggle class="mr-12"
            [checked]="isSeats"
            (toggleChange)="trnService.btnAction.next('seat-sel')"
          [disabled]="!trnService.seatsEnabled.value || loading">Scegli posti</mat-slide-toggle>
        }
      </div>
      <div class="text-right">
        @if (!['edit-date-time','carnet','travel-change'].includes(checkoutDataMode) && (isSeats || isReturn || !isAr)  ) {
          <button mat-raised-button
            (click)="trnService.btnAction.next('conf-sel')"
            [disabled]="loading"
            >
            <span>Continua</span>
            <mat-icon iconPositionEnd>keyboard_arrow_right</mat-icon>
          </button>
        }
        @if (['travel-change'].includes(checkoutDataMode) && isSelected && isSeats ) {
          <button mat-raised-button
            (click)="trnService.btnAction.next('conf-sel')"
            [disabled]="loading"
            >
            <span>Continua</span>
            <mat-icon iconPositionEnd>keyboard_arrow_right</mat-icon>
          </button>
        }
        <!--caso A/R-->
        @if (!['carnet'].includes(checkoutDataMode)&&(isAr && !isReturn)&&!isSeats) {
          <button mat-raised-button
            (click)="trnService.btnAction.next('conf-sel')"
            [disabled]="loading"
            >
            <span>Ritorno</span>
            <mat-icon iconPositionEnd>keyboard_arrow_right</mat-icon>
          </button>
        }
        @if (checkoutDataMode == 'travel-change' && isSelected && !isSeats) {
          <button mat-raised-button
            (click)="trnService.btnAction.next('travel-change')"
            [disabled]="loading"
            >
            <span>Aggiorna Tratta</span>
          </button>
        }
        @if (['carnet'].includes(checkoutDataMode)) {
          <button mat-flat-button color="primary"
            style="margin-left: 8px"
            [disabled]="loading"
            (click)="trnService.btnAction.next('confirm-carnet')">CONFERMA
          </button>
        }
      </div>
    </div>
  }
</div>